export default "__VITE_ASSET__BYe4t$ar__"